import PhoneIcon from "@medoma/components/icons/PhoneIcon";
import { Fragment } from "react";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import styles from "./CallChooser.module.scss";
import {
  MICROSOFT_TEAMS_PHONE_CALL_PREFIX,
  type LocalizedPhoneNumber,
} from "@medoma/models/phoneNumbers";
import { useUserProfile } from "@/api/Users";
import { organizationSchema } from "@medoma/models/organizations";
import { useLingui } from "@lingui/react/macro";

export const CallChooser = ({
  contacts,
}: {
  contacts: ReadonlyArray<{ name: string; phoneNumber: LocalizedPhoneNumber }>;
}) => {
  const { t } = useLingui();
  const { organization } = useUserProfile();
  return (
    <DropdownMenu
      trigger={{
        custom: (
          <div className={styles.phoneIcon}>
            <PhoneIcon />
          </div>
        ),
        ariaLabel: t`Ring telefonsamtal`,
      }}
    >
      {contacts.map(({ name, phoneNumber }, index) => (
        <Fragment key={name}>
          {index === 1 ? <DropdownMenu.Separator /> : undefined}
          <DropdownMenu.Item
            action={() =>
              window.open(
                organization === organizationSchema.enum.hahag ||
                  organization === organizationSchema.enum.ksgr
                  ? // HAHAG calls through Teams
                    `${MICROSOFT_TEAMS_PHONE_CALL_PREFIX}${phoneNumber}`
                  : `tel:${phoneNumber}`,
              )
            }
            content={`${name}`}
          />
        </Fragment>
      ))}
    </DropdownMenu>
  );
};
